import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { CustomJobAlertPage } from 'builder/components/FindJob/JobAlertPage/CustomJobAlertPage'

export const CustomJobAlertPageView = () => {
  useEffect(() => {
    trackInternalEvent('visit_job_ad_mjs', {
      label: 'custom',
    })
  }, [])
  return <CustomJobAlertPage />
}
